let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Qovwm")).then(() => parcelRequire('4oIfN'));